// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2533":"6b569339","5557":"2d3aec74","5635":"2d3aec74","6821":"2d3aec74","8064":"2d3aec74","9092":"2d3aec74","9682":"2d3aec74"}[chunkId] + ".chunk.css";
};